import Dexie from 'dexie';

const db = new Dexie('AirswiftTimesheetDB');

db.version(1).stores({
  // Offline drafts - auto-saved timesheet data
  drafts: 'timesheetId, userId, updatedAt, status',

  // Offline submission queue - timesheets queued for submit while offline
  submissionQueue: '++id, timesheetId, userId, type, createdAt, status',

  // Cached timesheet list
  timesheetList: 'userId, updatedAt',

  // Push notification subscription
  pushSubscription: 'userId'
});

export default db;